<script setup lang="ts">
import type { PropType } from 'vue';
import Ui2Radio from '../Ui2Radio/Ui2Radio.vue';
import type { Ui2FormSelectItem, UiFormSizes } from '@mop/ui2/types';

defineOptions({
  name: 'Ui2DropdownSelectItem',
});

defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  item: {
    type: Object as PropType<Ui2FormSelectItem>,
    required: true,
  },
  name: {
    type: String,
    default: '',
  },
  showRadioButtons: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<UiFormSizes>,
    default: 'md',
  },
  itemSize: {
    type: String as PropType<UiFormSizes>,
    default: 'sm',
  },
});

const iconSize = 20;
</script>

<template>
  <div
    :class="[
      'ui-dropdown__option',
      `ui-dropdown__option--${itemSize}`,
      {
        'ui-dropdown__option--active': active,
        'ui-dropdown__option--disabled': item.disabled,
        'ui-dropdown__option--border-top': item.borderTop,
      },
    ]"
  >
    <Ui2Icon v-if="item.icon" class="ui-dropdown-select__icon" name="mail" :width="iconSize" :height="iconSize" />
    <Ui2Radio
      v-if="showRadioButtons"
      class="ui-dropdown-select__radio"
      :model-value="String(modelValue)"
      :items="[
        {
          value: String(item.value),
          text: '',
        },
      ]"
      vertical
      :name="`radio-${name}`"
    />
    <div :class="['ui-dropdown-select__option-text', item.color ? `ui-${item.color}` : '']">
      {{ item.text }}
    </div>
    <div
      v-if="item.helperText || item.helperTextIcon"
      :class="['ui-dropdown-select__option-helper', item.helperTextColor ? `ui-${item.helperTextColor}` : '']"
    >
      <div v-if="item.helperText" class="ui-dropdown-select__option-helper-text">
        {{ item.helperText }}
      </div>
      <div v-if="item.helperTextIcon" class="ui-dropdown-select__option-helper-icon">
        <Ui2Icon
          v-if="item.helperTextIcon"
          class="ui-dropdown-select__icon"
          :name="item.helperTextIcon"
          :width="iconSize"
          :height="iconSize"
        />
      </div>
    </div>
    <Ui2Icon
      v-if="!showRadioButtons && selected"
      class="ui-dropdown-select__icon"
      name="check"
      :width="iconSize"
      :height="iconSize"
    />
  </div>
</template>

<style lang="scss">
@import './ui2dropdown.scss';

.ui-dropdown-select__radio {
  margin-right: $space-8;
}

.ui-dropdown-select__option-helper {
  @include v2-text-style(sm);
  margin-right: $space-8;
  display: flex;
  gap: $space-2;
}
</style>
